import { Component, Input, OnInit } from '@angular/core';
import { MemberCardBase } from '../member-card.base';

@Component({
  selector: 'fgb-member-card-with-wallet-button',
  templateUrl: './member-card-with-wallet-button.component.html',
  styleUrl: '../member-card-with-wallet.scss',
})
export class MemberCardWithWalletButtonComponent extends MemberCardBase implements OnInit {
  @Input() theme: string = 'primary';
  @Input() showWalletButton: boolean = true;

  ngOnInit() {
    super.init();
  }
}
